import React, { useCallback, useRef } from "react";
import PropTypes from 'prop-types';
import ReactDOM from "react-dom";
import { connect } from 'react-redux';
import { ObtenerConsumosEnAPI, EstadisticasConsumosTotalesEnAPI, abortFetch, GetCSVEnAPI } from "../../action/actionCreatorsRequests";
import {
    traducirPagina, dynamicSortAsc,
    descargarDocPasandoBase64Generico

} from "../../librerias/funciones"


import {
    ArrowUpOutlined,
    ArrowDownOutlined,
    CaretUpOutlined,
    CaretDownOutlined,
    LoadingOutlined,
    CloudDownloadOutlined

} from '@ant-design/icons';

import '../../styles/consumo.css'
import FiltersConsumos from "./FiltersConsumos";
import { Pagination } from "antd";

const cellCount = 5000;
const cellWidth = 400;
const cellHeight = 50;



const MantenimientoConsumos = ({ }) => {

    const firstControllerRef = useRef()
    const secondControllerRef = useRef()
    const ref = useRef(null)

    const [alturaSubmenu, setAlturaSubmenu] = React.useState(0);
    const [cabSocios, setCabSocios] = React.useState({});
    const [filtros, setFiltros] = React.useState({ ACTIVAR_UNIDADES: false, TXT_FILTRO: "" })
    const [bloqueoPantalla, setBloqueoPantalla] = React.useState({
        LOADER: true,
        MENSAJE: ""
    });

    const [datosPaginacion, setDatosPaginacion] = React.useState({ iniPage: 1, inicio: 1, final: 500, numPagina: 500 });





    /*
        const [initFilter, setInitFilter] = React.useState(
            {
            PAISES: [{ ID: 0, DESCRIPCION: "ESPAÑA", SELECCIONADO: false }, { ID: 1, DESCRIPCION: "PORTUGAL", SELECCIONADO: false }],
            PERIODO: [{ ID: 0, DESCRIPCION: 2022, SELECCIONADO: false }, { ID: 1, DESCRIPCION: 2021, SELECCIONADO: false }, { ID: 2, DESCRIPCION: 2020, SELECCIONADO: false }, { ID: 3, DESCRIPCION: 2019, SELECCIONADO: false }, { ID: 4, DESCRIPCION: 2018, SELECCIONADO: false }],
            ENTRE_MESES: { DESDE: 1, HASTA: 12 },
            FILTRO1: [{ ID: 0, DESCRIPCION: "Proveedor", SELECCIONADO: true }, { ID: 1, DESCRIPCION: "Familia", SELECCIONADO: false }, { ID: 2, DESCRIPCION: "SubFamilia", SELECCIONADO: false }, { ID: 3, DESCRIPCION: "Marca", SELECCIONADO: false }],
            FILTRO2: [
                { ID_PADRE: 0, ID: 0, DESCRIPCION: "Proveedor", SELECCIONADO: true },
                { ID_PADRE: 0, ID: 1, DESCRIPCION: "Familia y SubFamilia", SELECCIONADO: false },
                { ID_PADRE: 0, ID: 2, DESCRIPCION: "Marca", SELECCIONADO: false },
                { ID_PADRE: 0, ID: 3, DESCRIPCION: "SubFamilia", SELECCIONADO: false },
    
                { ID_PADRE: 1, ID: 0, DESCRIPCION: "Familia", SELECCIONADO: false },
                { ID_PADRE: 1, ID: 1, DESCRIPCION: "Marca", SELECCIONADO: false },
                { ID_PADRE: 1, ID: 2, DESCRIPCION: "Proveedor", SELECCIONADO: false },
                { ID_PADRE: 1, ID: 3, DESCRIPCION: "SubFamilia y marca", SELECCIONADO: false },
    
    
                { ID_PADRE: 2, ID: 0, DESCRIPCION: "SubFamilia", SELECCIONADO: false },
                { ID_PADRE: 2, ID: 1, DESCRIPCION: "Marca", SELECCIONADO: false },
                { ID_PADRE: 2, ID: 2, DESCRIPCION: "Proveedor", SELECCIONADO: false },
    
                { ID_PADRE: 3, ID: 0, DESCRIPCION: "Marca", SELECCIONADO: false },
                { ID_PADRE: 3, ID: 1, DESCRIPCION: "SubFamilia", SELECCIONADO: false },
            ],
            ACTIVAR_UNIDADES: false,
            TXT_FILTRO: "",
            ACTIVE_MENU: 0,
            INICIAL_MES: [
                { ID: 1, DESCRIPCION: "ENE" },
                { ID: 2, DESCRIPCION: "FEB" },
                { ID: 3, DESCRIPCION: "MAR" },
                { ID: 4, DESCRIPCION: "ABR" },
                { ID: 5, DESCRIPCION: "MAY" },
                { ID: 6, DESCRIPCION: "JUN" },
                { ID: 7, DESCRIPCION: "JUL" },
                { ID: 8, DESCRIPCION: "AGO" },
                { ID: 9, DESCRIPCION: "SEP" },
                { ID: 10, DESCRIPCION: "OCT" },
                { ID: 11, DESCRIPCION: "NOV" },
                { ID: 12, DESCRIPCION: "DIC" },
            ]
        }
        );
        */





    const [consumos, setConsumos] = React.useState({})
    /*
        const abortLocal = () => {
            firstController.abort();
            secondController.abort();
        }
    */


    const paginarTabla = (page, pageSize) => {
        let pInicio = (pageSize * page) - (datosPaginacion.numPagina);
        let pFinal = pageSize * page;
        setDatosPaginacion(
            {
                iniPage: page,
                inicio: pInicio,
                final: pFinal,
                numPagina: datosPaginacion.numPagina
            }
        )

    }

    const updateNumberPage = (current, size) => {
        setDatosPaginacion(
            {
                iniPage: 1,
                inicio: 1,
                final: size,
                numPagina: size
            }
        )
    }


    const actualizarFiltro = (initFilter) => {
        const { ACTIVAR_UNIDADES, TXT_FILTRO } = initFilter
        filtros.ACTIVAR_UNIDADES = ACTIVAR_UNIDADES
        filtros.TXT_FILTRO = TXT_FILTRO
        setFiltros({ ...filtros })


    }

    const ObtenerConsumos = async (FILTRO1, FILTRO2, ACCION_DESDE, ACCION_HASTA, ANYO, PAIS, ID_SOCIO, DESCARGAR_CSV) => {
        bloqueoPantalla.LOADER = true
        setBloqueoPantalla({ ...bloqueoPantalla })
        setConsumos({})

        setDatosPaginacion({ iniPage: 1, inicio: 1, final: 500, numPagina: 500 })

        DESCARGAR_CSV = DESCARGAR_CSV === undefined ? false : DESCARGAR_CSV

        if (firstControllerRef.current) {
            firstControllerRef.current.abort();
        }
        firstControllerRef.current = new AbortController();
        const signal = firstControllerRef.current.signal

        let registro = await ObtenerConsumosEnAPI(FILTRO1, FILTRO2, ACCION_DESDE, ACCION_HASTA, ANYO, PAIS, ID_SOCIO, DESCARGAR_CSV, signal)
        console.log("registro", registro)

        if (registro !== undefined && registro !== null) {

            if (registro.CABECERAS !== undefined && registro.CABECERAS !== null) {
                registro.CABECERAS.map((item) => item.FILTRO = { DIR: "DESC", ACTIVAR: false, CAMPO: item.CAMPO })
            }

            setConsumos(registro)
        } else {
            /*
            setConsumos({
                OK: false,
                MENSAJE_ERROR: null,
                REGISTROS: null,
                CABECERAS: null,
                RESUMEN: null,
                CSV: null
            })
*/
        }

        bloqueoPantalla.LOADER = false
        setBloqueoPantalla({ ...bloqueoPantalla })

    }



    const EstadisticasConsumosTotales = async (ANYO, PAIS, ID_SOCIO, ACCION_DESDE, ACCION_HASTA) => {
        setCabSocios({})


        if (secondControllerRef.current) {
            secondControllerRef.current.abort();
        }
        secondControllerRef.current = new AbortController();
        const signal = secondControllerRef.current.signal


        let registro = await EstadisticasConsumosTotalesEnAPI(ANYO, PAIS, ID_SOCIO, ACCION_DESDE, ACCION_HASTA, signal)
        if (registro !== undefined && registro !== null) {
            setCabSocios(registro.REGISTROS[0])
        }
    }

    const ObtenerHtml = (cadena) => {
        let RESULTADO = cadena
        cadena = cadena !== undefined && cadena !== null ? cadena : ""

        if (cadena.includes("div")) {
            let dom = document.createElement('div');
            dom.innerHTML = cadena;
            let color = dom.children[0].attributes[0] !== undefined ? dom.children[0].attributes[0].value : ""
            RESULTADO = <div style={{ color: color.split(":")[1] }} className="center_text_table"><> <>{dom.innerText}</> <> {cadena.includes("ArrowUpOutlined") ? <ArrowUpOutlined></ArrowUpOutlined> : cadena.includes("ArrowDownOutlined") ? <ArrowDownOutlined></ArrowDownOutlined> : null}</> </> </div>
        }

        return RESULTADO
    }

    const ponerColorSegunNivel = (registro) => {
        const { NIVEL } = registro
        let nombreClase = ""
        switch (NIVEL) {
            case 0:
                nombreClase = "bg-secondary-light"
                break;
            case 1:
                nombreClase = "bg-greyer"
                break;
            case 2:
                nombreClase = "bg-grey"
                break;
        }
        return nombreClase;
    }

    const seleccionadoActual = (registros) => {
        let REGISTRO = registros.find((registro) => registro.SELECCIONADO)
        return REGISTRO === undefined ? { ID: null, DESCRIPCION: null } : REGISTRO
    }


    const filtrarTabla = (REGISTROS, TEXTO_FILTRO, CABECERAS) => {
        TEXTO_FILTRO = TEXTO_FILTRO.toUpperCase();

        //BUSCADOR TABLA

        if (TEXTO_FILTRO !== "") {
            let BUSCAR_FILTRO = CABECERAS.find((item) => item.ORDEN === 1).CAMPO

            let RESULTADOS = REGISTROS.filter((item) => {
                let OBJETO = eval(`item.${BUSCAR_FILTRO}`)
                return OBJETO.toUpperCase().includes(TEXTO_FILTRO) || OBJETO.toUpperCase() === TEXTO_FILTRO
            })


            let AGRUPAR_IDS = RESULTADOS.map((item) => eval(`item.ID_${BUSCAR_FILTRO}`))


            if (AGRUPAR_IDS !== undefined && AGRUPAR_IDS !== null && AGRUPAR_IDS.length > 0) {
                RESULTADOS = REGISTROS.filter((item) => {
                    let OBJETO = eval(`item.ID_${BUSCAR_FILTRO}`)
                    return AGRUPAR_IDS.includes(OBJETO)
                })
            }


            REGISTROS = RESULTADOS
        }
        return REGISTROS;
    }

    const descargarDocumento = async (registros) => {
        const result = await GetCSVEnAPI(registros)
        if (result !== undefined && result.CSV !== null && result.CSV !== "") {
            descargarDocPasandoBase64Generico(result.CSV, "csv")
        }
    }

    React.useEffect(() => {
        if (ref.current !== null) {
            setAlturaSubmenu(ref.current.clientHeight)
        }
    })


    document.getElementById("tituloMenu") !== null && ReactDOM.render(
        <>
            {traducirPagina("Mis_consumos").toUpperCase()}
        </>,
        document.getElementById("tituloMenu")
    );


    function renderCell({ index, key, style }) {
        return (

            <div key={key} style={style} className="row">
                <div className="image">
                </div>
                <div className="content">
                </div>
            </div>
        );

    }


    function cellSizeAndPositionGetter({ index }) {
        return {
            height: cellHeight,
            width: cellWidth,
            y: index * cellHeight,
            x: Math.floor(Math.random() * 10) * cellWidth
        }
    }


    const { CABECERAS, REGISTROS } = consumos

    /*
        const rowRenderer = useCallback(
            ({ key, index, style, parent }) => {
                const item = index;
                console.log("ROW", item)
                return (
                    <CellMeasurer
                        key={key}
                        columnIndex={0}
                        parent={parent}
                        rowIndex={index}>
                        <div >
                            Your row info
                        </div>
                    </CellMeasurer>
                );
            },
            []
        );
        
    */




    const CustomRowRendererComponent = ({
        key, index
    }) => {
        const row = REGISTROS[index]
        console.log("row", row, "index", index)

        return (

            <div className={`${ponerColorSegunNivel(REGISTROS[index])}`} style={{ display: 'flex' }}>
                {CABECERAS.sort(dynamicSortAsc("ORDEN")).map((item) =>
                    item.UNIDADES && filtros.ACTIVAR_UNIDADES ?
                        null
                        :
                        <div style={{ border: '1px solid #d9d9d9', padding: '4px', justifyContent: item.ALINEADO, flex: item.ANCHO === "" ? "1" : `0 1 ${item.ANCHO}px` }}>
                            {ObtenerHtml(eval(`row.${item.CAMPO}`))}
                        </div>
                )}
            </div>


        );
    }


    function rowRenderer({ key, index }) {
        // console.log("render", index, REGISTROS[index])
        const row = REGISTROS[index]

        return (

            <div key={key} className={`${ponerColorSegunNivel(REGISTROS[index])}`} style={{ display: 'flex' }}>
                {CABECERAS.sort(dynamicSortAsc("ORDEN")).map((item) =>
                    item.UNIDADES && filtros.ACTIVAR_UNIDADES ?
                        null
                        :
                        <div style={{ border: '1px solid #d9d9d9', padding: '4px', justifyContent: item.ALINEADO, flex: item.ANCHO === "" ? "1" : `0 1 ${item.ANCHO}px` }}>
                            {ObtenerHtml(eval(`row.${item.CAMPO}`))}
                        </div>
                )}
            </div>


        );
    }



    function rowRendererGrid({ key, rowIndex, columnIndex }) {
        console.log("render", rowIndex, columnIndex)
        // let row = REGISTROS[rowIndex]
        /*
                return (
        
                    <div key={key} className={`${ponerColorSegunNivel(REGISTROS[rowIndex])}`} style={{ display: 'flex' }}>
                      
                        {CABECERAS.sort(dynamicSortAsc("ORDEN")).map((item) =>
                            item.UNIDADES && filtros.ACTIVAR_UNIDADES ?
                                null
                                :
                                <div style={{ border: '1px solid #d9d9d9', padding: '4px', justifyContent: item.ALINEADO, flex: item.ANCHO === "" ? "1" : `0 1 ${item.ANCHO}px` }}>
                                    {ObtenerHtml(eval(`row.${item.CAMPO}`))}
                                </div>
                        )}
                    </div>
        
        
                );
                */
        return (<div>data</div>)
    }

    const columns = [
        {
            title: 'Name',
            dataIndex: 'name',
            key: 'name',
        },
        {
            title: 'Age',
            dataIndex: 'age',
            key: 'age',
        },
        {
            title: 'Address',
            dataIndex: 'address',
            key: 'address',
        }]

    const REGISTROS_TABLA = CABECERAS === undefined || CABECERAS === null || REGISTROS === undefined || REGISTROS === null ? [] : filtrarTabla(REGISTROS, filtros.TXT_FILTRO, CABECERAS)
    return (
        <>
            <div style={{ padding: '20px' }} ref={ref}>
                <FiltersConsumos
                    CABECERAS={CABECERAS}
                    REGISTROS_TABLA={REGISTROS_TABLA}
                    
                    ObtenerConsumos={ObtenerConsumos}
                    EstadisticasConsumosTotales={EstadisticasConsumosTotales}

                    eventPais={(registro, initFilter) => {
                        ObtenerConsumos(seleccionadoActual(initFilter.FILTRO1).ID, seleccionadoActual(initFilter.FILTRO2).ID, initFilter.ENTRE_MESES.DESDE, initFilter.ENTRE_MESES.HASTA, seleccionadoActual(initFilter.PERIODO).DESCRIPCION, registro.ID, initFilter.ID_SOCIO)
                        EstadisticasConsumosTotales(seleccionadoActual(initFilter.PERIODO).DESCRIPCION, registro.ID, initFilter.ID_SOCIO, initFilter.ENTRE_MESES.DESDE, initFilter.ENTRE_MESES.HASTA)

                    }}
                    eventPeriodo={(registro, initFilter) => {
                        ObtenerConsumos(seleccionadoActual(initFilter.FILTRO1).ID, seleccionadoActual(initFilter.FILTRO2).ID, initFilter.ENTRE_MESES.DESDE, initFilter.ENTRE_MESES.HASTA, registro.DESCRIPCION, seleccionadoActual(initFilter.PAISES).ID, initFilter.ID_SOCIO)
                        EstadisticasConsumosTotales(registro.DESCRIPCION, seleccionadoActual(initFilter.PAISES).ID, initFilter.ID_SOCIO, initFilter.ENTRE_MESES.DESDE, initFilter.ENTRE_MESES.HASTA)

                    }}
                    eventEntreFechas={(initFilter) => {
                        ObtenerConsumos(seleccionadoActual(initFilter.FILTRO1).ID, seleccionadoActual(initFilter.FILTRO2).ID, initFilter.ENTRE_MESES.DESDE, initFilter.ENTRE_MESES.HASTA, seleccionadoActual(initFilter.PERIODO).DESCRIPCION, seleccionadoActual(initFilter.PAISES).ID, initFilter.ID_SOCIO)
                        EstadisticasConsumosTotales(seleccionadoActual(initFilter.PERIODO).DESCRIPCION, seleccionadoActual(initFilter.PAISES).ID, initFilter.ID_SOCIO, initFilter.ENTRE_MESES.DESDE, initFilter.ENTRE_MESES.HASTA)
                    }}
                    eventSelect1={(registro, initFilter) => {
                        ObtenerConsumos(registro.ID, 0, initFilter.ENTRE_MESES.DESDE, initFilter.ENTRE_MESES.HASTA, seleccionadoActual(initFilter.PERIODO).DESCRIPCION, seleccionadoActual(initFilter.PAISES).ID, initFilter.ID_SOCIO)
                        EstadisticasConsumosTotales(seleccionadoActual(initFilter.PERIODO).DESCRIPCION, seleccionadoActual(initFilter.PAISES).ID, initFilter.ID_SOCIO, initFilter.ENTRE_MESES.DESDE, initFilter.ENTRE_MESES.HASTA)
                    }}
                    eventSelect2={(registro, initFilter) => {
                        ObtenerConsumos(registro.ID_PADRE, registro.ID, initFilter.ENTRE_MESES.DESDE, initFilter.ENTRE_MESES.HASTA, seleccionadoActual(initFilter.PERIODO).DESCRIPCION, seleccionadoActual(initFilter.PAISES).ID, initFilter.ID_SOCIO)
                        EstadisticasConsumosTotales(seleccionadoActual(initFilter.PERIODO).DESCRIPCION, seleccionadoActual(initFilter.PAISES).ID, initFilter.ID_SOCIO, initFilter.ENTRE_MESES.DESDE, initFilter.ENTRE_MESES.HASTA)
                    }}
                    eventActualizarTabla={(initFilter) => {
                        ObtenerConsumos(seleccionadoActual(initFilter.FILTRO1).ID, seleccionadoActual(initFilter.FILTRO2).ID, initFilter.ENTRE_MESES.DESDE, initFilter.ENTRE_MESES.HASTA, seleccionadoActual(initFilter.PERIODO).DESCRIPCION, seleccionadoActual(initFilter.PAISES).ID, initFilter.ID_SOCIO)
                        EstadisticasConsumosTotales(seleccionadoActual(initFilter.PERIODO).DESCRIPCION, seleccionadoActual(initFilter.PAISES).ID, initFilter.ID_SOCIO, initFilter.ENTRE_MESES.DESDE, initFilter.ENTRE_MESES.HASTA)
                    }}

                    eventSelectSocio={(e, initFilter) => {
                        ObtenerConsumos(seleccionadoActual(initFilter.FILTRO1).ID, seleccionadoActual(initFilter.FILTRO2).ID, initFilter.ENTRE_MESES.DESDE, initFilter.ENTRE_MESES.HASTA, seleccionadoActual(initFilter.PERIODO).DESCRIPCION, seleccionadoActual(initFilter.PAISES).ID, initFilter.ID_SOCIO)
                        EstadisticasConsumosTotales(seleccionadoActual(initFilter.PERIODO).DESCRIPCION, seleccionadoActual(initFilter.PAISES).ID, initFilter.ID_SOCIO, initFilter.ENTRE_MESES.DESDE, initFilter.ENTRE_MESES.HASTA)
                    }}

                    eventUnidades={(initFilter) => { actualizarFiltro(initFilter) }}
                    eventTextoFiltro={(initFilter) => {
                        actualizarFiltro(initFilter);

                        setDatosPaginacion({ iniPage: 1, inicio: 1, final: 500, numPagina: 500 })
                    }}
                >


                </FiltersConsumos>


                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <div className='mantenimiento_item1 container_resumen' style={{ gap: '10px' }}>
                        {Object.keys(cabSocios).length > 0 &&
                            <>
                                {
                                    cabSocios.IMPORTE_GRUPO_ACTUAL !== null && cabSocios.IMPORTE_GRUPO_ACTUAL !== "" &&
                                    <div>
                                        <small>Ej. actual grupo </small>
                                        <h3 style={{ color: 'var(--azul-claro-serca)' }}>{cabSocios.IMPORTE_GRUPO_ACTUAL}</h3>
                                    </div>
                                }



                                {
                                    cabSocios.IMPORTE_GRUPO_ANTERIOR !== null && cabSocios.IMPORTE_GRUPO_ANTERIOR !== "" &&
                                    <div>
                                        <small>Ej. anterior grupo</small>
                                        <h3>{cabSocios.IMPORTE_GRUPO_ANTERIOR}</h3>
                                    </div>
                                }


                                {
                                    cabSocios.IMPORTE_PAIS_ACTUAL !== null && cabSocios.IMPORTE_PAIS_ACTUAL !== "" &&
                                    <div>
                                        <small>Ej. actual pais</small>
                                        <h3 style={{ color: 'var(--azul-claro-serca)' }}>{cabSocios.IMPORTE_PAIS_ACTUAL}</h3>
                                    </div>
                                }



                                {
                                    cabSocios.IMPORTE_PAIS_ANTERIOR !== null && cabSocios.IMPORTE_PAIS_ANTERIOR !== "" &&
                                    <div>
                                        <small>Ej. anterior país</small>
                                        <h3>{cabSocios.IMPORTE_PAIS_ANTERIOR}</h3>
                                    </div>
                                }

                                {
                                    cabSocios.IMPORTE_SOCIO_ACTUAL !== null && cabSocios.IMPORTE_SOCIO_ACTUAL !== "" &&
                                    <div>
                                        <small>Ej. actual socio</small>
                                        <h3 style={{ color: 'var(--azul-claro-serca)' }}>{cabSocios.IMPORTE_SOCIO_ACTUAL}</h3>
                                    </div>
                                }



                                {
                                    cabSocios.IMPORTE_SOCIO_ANTERIOR !== null && cabSocios.IMPORTE_SOCIO_ANTERIOR !== "" &&
                                    <div>
                                        <small>Ej. anterior socio</small>
                                        <h3>{cabSocios.IMPORTE_SOCIO_ANTERIOR}</h3>
                                    </div>
                                }

                                {

                                    cabSocios.TENDENCIA_GRUPO !== null && cabSocios.TENDENCIA_GRUPO !== "" &&
                                    <div className="porcentaje_resumen" style={{ color: cabSocios.TENDENCIA_GRUPO.includes("-") ? "red" : "#1AB394" }}>
                                        <h3 style={{ color: cabSocios.TENDENCIA_GRUPO.includes("-") ? "red" : "#1AB394" }}>{cabSocios.TENDENCIA_GRUPO}</h3>
                                        {
                                            cabSocios.TENDENCIA_GRUPO.includes("-") ?
                                                <CaretDownOutlined></CaretDownOutlined>
                                                :
                                                <CaretUpOutlined></CaretUpOutlined>
                                        }
                                    </div>

                                }


                            </>
                        }

                    </div>

                    <div className='mantenimiento_item2 container_resumen' style={{ gap: '10px' }}>

                        {

                            (REGISTROS_TABLA !== undefined && REGISTROS_TABLA !== null && REGISTROS_TABLA.length > 0) &&
                            <div>
                                <small>{traducirPagina("Total_registros")}</small>
                                <h3 style={{ textAlign: 'right' }}>{REGISTROS_TABLA.length}</h3>
                            </div>

                        }

                    </div>


                </div>
            </div>

            {
                <div className="margen_tabla">
                    {
                        Object.keys(consumos).length > 0 ?
                            <>
                                <div className="container_tabla_generico" style={{ height: `calc(100vh - ${(175 + alturaSubmenu)}px )` }}>
                                    {
                                        CABECERAS === null || REGISTROS === null ?
                                            <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', textAlign: 'center', minHeight: '60vh' }}> <h3>{traducirPagina("Sin_resultados")}</h3> </div>
                                            :
                                            <>
                                                {/*REGISTROS.length > 0 && (
                                                <AutoSizer>
                                                    {
                                                        ({ width, height }) => (
                                                            <>

                                                                <Table
                                                                    width={width}
                                                                    height={height}
                                                                    headerHeight={30}
                                                                    headerClassName="formato_cabecera_virtual"
                                                                    className="header_virtual"
                                                                    rowHeight={30}
                                                                    rowCount={REGISTROS.length}
                                                                    rowGetter={({ index, key }) => REGISTROS[index]}
                                                                    rowRenderer={({ index, key }) => CustomRowRendererComponent({ index, key })}


                                                                >
                                                                    {CABECERAS.sort(dynamicSortAsc("ORDEN")).map((registro) =>
                                                                        registro.UNIDADES && filtros.ACTIVAR_UNIDADES ?
                                                                            null
                                                                            :
                                                                            <Column
                                                                                width={registro.ANCHO}
                                                                                label={registro.TEXTO}
                                                                                dataKey={registro.CAMPO}
                                                                                headerStyle={{ justifyContent: `${registro.ALINEADO}` }}
                                                                                headerClassName={registro.ANCHO === "" ? "ancho_Column_virtual" : ""}

                                                                            />
                                                                    )}


                                                                </Table>



                                                            </>
                                                        )
                                                    }
                                                </AutoSizer>
                                            )*/}

                                                {

                                                    <table style={{ width: '100%', color: '#000' }} className="tabla_dinamica">
                                                        <thead>
                                                            <tr style={{ backgroundColor: 'var(--azul-claro-serca)', color: '#fff' }}>
                                                                {CABECERAS.sort(dynamicSortAsc("ORDEN")).map((registro) =>
                                                                    registro.UNIDADES && filtros.ACTIVAR_UNIDADES ?
                                                                        null
                                                                        :
                                                                        <th className={`formatear_cabecera_icono`} style={{ width: `${registro.ANCHO}px `, border: '1px solid #d9d9d9', padding: '4px', textAlign: registro.ALINEADO, }} >

                                                                            {registro.TEXTO}


                                                                        </th>
                                                                )}
                                                            </tr>
                                                        </thead>
                                                        <tbody>


                                                            {REGISTROS === null ?
                                                                null
                                                                :
                                                                REGISTROS !== null && REGISTROS.length > 0 ?

                                                                    REGISTROS_TABLA.map((registro, i) =>
                                                                        (i + 1) >= datosPaginacion.inicio && (i + 1) <= datosPaginacion.final && (
                                                                            <tr key={i} className={`${ponerColorSegunNivel(registro)}`} >
                                                                                {CABECERAS.sort(dynamicSortAsc("ORDEN")).map((item) =>
                                                                                    item.UNIDADES && filtros.ACTIVAR_UNIDADES ?
                                                                                        null
                                                                                        :
                                                                                        <td style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: item.ALINEADO }}>{ObtenerHtml(eval(`registro.${item.CAMPO}`))}</td>
                                                                                )}
                                                                            </tr>
                                                                        )
                                                                    )
                                                                    :
                                                                    null
                                                            }

                                                        </tbody>
                                                    </table>
                                                }


                                            </>
                                    }

                                </div>


                                <div className="menu_mantenimiento" style={{ paddingBottom: '0px', justifyContent: 'center' }}>
                                    {REGISTROS_TABLA !== null && REGISTROS_TABLA.length > 0 ?
                                        <Pagination
                                            showSizeChanger
                                            current={datosPaginacion.iniPage}
                                            onShowSizeChange={(current, size) => { updateNumberPage(current, size) }}
                                            total={REGISTROS_TABLA.length}
                                            showTotal={() => ` ${REGISTROS_TABLA.length} ${traducirPagina("registros")}`}
                                            defaultPageSize={500}
                                            onChange={(page, pageSize) => { paginarTabla(page, pageSize) }}
                                        > </Pagination>
                                        :
                                        null
                                    }

                                </div>

                            </>

                            :

                            <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', textAlign: 'center', minHeight: '60vh' }}>

                                <div className="msg_consumo">
                                    <div>{traducirPagina("Msg_proceso_espera_segundos")}</div>
                                    <div><LoadingOutlined /> </div>
                                </div>

                            </div>
                    }
                </div>


            }

            {/* bloqueoPantalla.LOADER ?
                <div className="pantallaBloqueo">
                    <div className="image-mask-info" style={{ fontSize: '18px' }}>
                        <div className="container_msg_consumo">

                            <div className="msg_consumo">
                                <div><LoadingOutlined /> </div>
                                <div>{traducirPagina("Msg_proceso_espera_segundos")}</div>
                            </div>


                            <button className="btn_exit_consumo" onClick={() => {
                                abortFetch()

                                bloqueoPantalla.LOADER = false
                                setBloqueoPantalla({ ...bloqueoPantalla })

                            }}>{traducirPagina("Cancelar_peticion")}</button>
                            

                        </div>
                    </div>
                </div>

                :

                null
                        */}
        </>
    );
}


MantenimientoConsumos.propTypes = {
    EVENTO_MENU: PropTypes.func
};

const mapStateToProps = (state, props) => {
    return {
        props: props,

    };
}

export default connect(mapStateToProps)(MantenimientoConsumos);